export default "__VITE_ASSET__77474db9__"